export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'title',
		label: 'Title',
		selector: '& .text' /* Closest thing we can target, to make e.g. background clip still function */
	}
]